import { Flex, Progress, Space, Tag, theme } from 'antd'

import { AnswerChoiceResponse, AnswerStats } from 'src/api/requests'
import { Text } from 'src/components'
import { useStyles } from 'src/features/questionnaires/styles'
import { getPercentage } from 'src/features/questionnaires/utils'
import { useLocales } from 'src/locales'

type Props = {
  choices?: (AnswerChoiceResponse & AnswerStats)[]
  totalResponses: number
}

export const Choices = ({ choices, totalResponses }: Props) => {
  const { t, currentLang } = useLocales()

  const { token } = theme.useToken()

  const { styles } = useStyles()

  return (
    <Flex vertical gap={8}>
      {choices?.map((choice) => {
        const percentage = getPercentage(choice?.count, totalResponses)

        return (
          <Flex key={choice.id} vertical gap={8}>
            <Text>{choice?.text?.[currentLang?.value]}</Text>
            <Flex align="center" justify="center" gap={24}>
              <Progress
                percent={percentage}
                strokeColor={token.colorPrimary}
                className={styles.progress}
              />
              <Tag color="blue" className={styles.tag}>
                {percentage}%
              </Tag>
              <Space size={4}>
                {choice?.count} {t('questionnaires.persons')}
              </Space>
            </Flex>
          </Flex>
        )
      })}
    </Flex>
  )
}
